// extracted by mini-css-extract-plugin
export default {"main_container":"Home_main_container__qQE1a","right_content":"Home_right_content__-qvH8"};